<template>
  <div class="footer">
    <div class="footer_wrap w flex3">
      <div class="box box1 flex2">
        <div class="item">
          <div class="title">NAVIGATION</div>
          <ul class="content">
            <li @click="toPage(0)">HOMEPAGE</li>
            <li @click="toPage(1)">SERVICES</li>
            <li @click="toPage(3)">ABOUT US</li>
            <li @click="toPage(4)">CONTACT</li>
          </ul>
        </div>
        <div class="item">
          <div class="title">SERVICE</div>
          <ul class="content">
            <li @click="toService(0)">CNC Machining</li>
            <li @click="toService(1)">Injection Molding</li>
            <li @click="toService(2)">Sheet Metal Prototyping</li>
          </ul>
        </div>

        <div class="item">
          <ul class="content">
            <li @click="toService(3)">Mold Making</li>
            <li @click="toService(4)">3D Printing</li>
            <li @click="toService(5)">Surface Finishing</li>
          </ul>
        </div>
        <div class="item">
          <div class="title">NAVIGATION</div>
          <ul class="content">
            <li>Advantages of CNC</li>
            <li>CNC NC machining</li>
            <li>Features of 5 axis</li>
            <li>What is CNC?</li>
          </ul>
        </div>
      </div>
      <div class="box box2">
        <div class="phone">13543292500</div>
        <div class="mail">
          <img class="icon" src="../assets/images/common/email.png" />
          mail：joesguichang@gmail.com
          </div>
        <div class="adress">
          <img class="icon" src="../assets/images/common/adress.png" />
          Add：Room 205, 2nd Floor, No.2 shuaifu Street, Wanjiang Street, Dongguan city, Guangdong, China
        </div>
      </div>
      <div class="box box3">
        <img class="qrcode" src="../assets/images/common/qrcode.png" />
        <span>Scan to open mobile website~</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {}
  },
  props: {},
  methods: {
    toPage(index){
      if(index===0){
        this.$router.push({ path: '/' })
      }else if(index===1){
         this.$router.push({ path: '/service' })
      }else if(index===3){
         this.$router.push({ path: '/about' })
      }else if(index===4){
         this.$router.push({ path: '/contact' })
      }
    },
        toService(index){
          if(this.$route.path=='/service'){
            return
          }
     this.$router.push({ path: "/service?index=" + index+"&showDetail="+false });
    }
  },
}
</script>
<style scoped>
.footer {
  width: 100%;
  height: 227px;
  background: #2d2d2d;
  color: #fff;
  font-size: 12px;
}
.footer_wrap {
  box-sizing: border-box;
  padding: 36px 0;
}
.box {
  height: 100%;
}
.box1 {
  width: 740px;
}
.box1 .item {
  position: relative;
  height: 100%;
  flex: 1;
}
.box1 .item .title {
  font-size: 18px;
  line-height: 18px;
}
.box1 .item .content {
  position: absolute;
  top: 43px;
}
.box1 .item .content li {
  line-height: 30px;
}
.box2 {
  width: 278px;
  border-left: 1px solid #6a6a6a;
  padding: 0px 26px;
}
.box2 .phone{
  font-size: 26px;
  line-height: 26px;
  color: #008AFF;
  font-style: italic;
  margin-bottom: 30px;
  white-space: nowrap;
}
.box2 .mail,
.box2 .adress{
  position: relative;
  margin-bottom: 22px;
  padding-left: 30px;
  line-height: 26px;
}
.box2 .icon{
  position: absolute;
  top: 6px;
  left: 0;
  width: 18px;
}
.box3 {
  flex: 1;
  border-left: 1px solid #6a6a6a;
  padding-left: 23px;
}
.box3 .qrcode{
  width: 134px;
  height: 134px;
  background: #092E48;
  margin-bottom: 10px;

}
.box3 span{
  display: block;
  width: 100%;
  line-height: 18px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue